<div class="overlay">
	<div class="spinner">
		<img style="width: 80px; height: 80px" src="../../../../assets/icons/loader/spinner.gif" />
	</div>
</div>
